module.exports = __webpack_public_path__ + "static/examining_arkansas-871a9c21175f269891dc37fc4aef8123.png";